import { memo } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

import useWindowDimensions from "../../utils/useWindowDimensions";

import {
  reorderedRoutesListSelector,
  driversSelector,
  vehiclesSelector,
} from "../../reducers/matrixProfile/selectors";

import { View } from "../Base";
import RouteList from "./RouteList";
import RouteViews from "./RouteViews";
import { RouteSortBar } from "./RouteSortBar";
import { RouteExtractBar } from "./RouteExtractBar";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
});

export const RouteDetail = memo(() => {
  const styles = useStyles();
  const routes = useSelector(reorderedRoutesListSelector);
  const drivers = useSelector(driversSelector);
  const vehicles = useSelector(vehiclesSelector);
  const { height: windowHeight } = useWindowDimensions();

  return (
    <div className={styles.container}>
      <RouteViews />
      <RouteSortBar />
      <View className={styles.list}>
        <RouteList
          routes={routes}
          drivers={drivers}
          vehicles={vehicles}
          height={windowHeight - 277}
        />
      </View>
      <RouteExtractBar routes={routes} drivers={drivers} />
    </div>
  );
});

export default RouteDetail;
